module.exports = __webpack_public_path__ + "assets/img/logo.af0ec9ddd2b745bf543bf21a20e0cac6.png";